export default __webpack_public_path__ + "static/media/search.eb3f6713.svg";